import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/templates/")({
  beforeLoad: () => {
    throw redirect({ to: "/templates/tasks", replace: true })
  },
})
